import React from "react";
import { Check, Crown } from "lucide-react";
import { PACKAGES, WHATSAPP_URL } from "../data/site";

const buildWaLink = (p) => {
    const msg = `Ciao Manuel! Sono interessato al pacchetto *${p.name}* (€${p.price}). Vorrei avere maggiori informazioni.`;
    return `${WHATSAPP_URL}?text=${encodeURIComponent(msg)}`;
};

export default function Packages() {
    return (
        <section
            id="pacchetti"
            data-testid="packages-section"
            className="relative py-24 sm:py-32 overflow-hidden"
        >
            <div className="absolute inset-0 bg-grid opacity-25" />
            <div className="absolute top-1/3 -left-32 w-[400px] h-[400px] rounded-full bg-gold/5 blur-3xl" />

            <div className="container mx-auto px-4 sm:px-6 lg:px-10 relative">
                <div className="max-w-3xl">
                    <div className="font-manrope text-sm uppercase tracking-[0.3em] text-gold mb-4">
                        Pacchetti
                    </div>
                    <h2
                        data-testid="packages-title"
                        className="font-oswald font-bold uppercase text-4xl sm:text-5xl lg:text-6xl text-white leading-[1]"
                    >
                        Scegli il tuo
                        <br />
                        <span className="text-shimmer">percorso.</span>
                    </h2>
                    <p className="mt-6 font-manrope text-zinc-400 text-base sm:text-lg max-w-2xl">
                        Tre pacchetti pensati per ogni esigenza. Pagamenti flessibili e a rate
                        disponibili: carta, bonifico o contanti.
                    </p>
                </div>

                <div className="mt-14 grid md:grid-cols-3 gap-6 sm:gap-8 items-stretch">
                    {PACKAGES.map((p) => (
                        <article
                            key={p.id}
                            data-testid={`package-${p.id}`}
                            className={`relative flex flex-col rounded-2xl overflow-hidden border transition-all duration-500 hover:-translate-y-2 ${
                                p.highlight
                                    ? "border-gold bg-gradient-to-b from-gold/10 to-ink-surface shadow-[0_20px_60px_rgba(212,175,55,0.2)]"
                                    : "border-white/10 bg-ink-surface hover:border-gold/40"
                            }`}
                        >
                            {p.highlight && (
                                <div className="absolute top-4 right-4 z-10 inline-flex items-center gap-1.5 bg-gold text-ink font-oswald font-bold uppercase text-[10px] tracking-widest px-3 py-1.5 rounded-full">
                                    <Crown size={12} />
                                    Più richiesto
                                </div>
                            )}

                            {/* image area */}
                            <div className="relative aspect-[4/3] bg-black flex items-center justify-center overflow-hidden">
                                <img
                                    src={p.image}
                                    alt={p.name}
                                    className="w-full h-full object-cover"
                                    style={{ objectPosition: p.id === "basic" ? "center top" : "center" }}
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-ink-surface to-transparent" />
                            </div>

                            <div className="p-7 sm:p-8 flex-1 flex flex-col">
                                <div className="font-manrope text-[11px] uppercase tracking-[0.3em] text-gold">
                                    {p.coach}
                                </div>
                                <h3 className="font-oswald font-bold uppercase text-2xl sm:text-3xl text-white mt-2 tracking-wide">
                                    {p.name}
                                </h3>
                                <p className="font-manrope text-sm text-zinc-400 mt-1">
                                    {p.tagline}
                                </p>

                                <div className="flex items-baseline gap-1 mt-6">
                                    <span className="font-oswald font-bold text-5xl text-white">
                                        €{p.price}
                                    </span>
                                    <span className="font-manrope text-sm text-zinc-500">
                                        /mese
                                    </span>
                                </div>

                                <ul className="mt-6 space-y-3 flex-1">
                                    {p.bullets.map((b) => (
                                        <li
                                            key={b}
                                            className="flex items-start gap-3 font-manrope text-sm text-zinc-200"
                                        >
                                            <div className="flex-shrink-0 w-5 h-5 rounded-full bg-gold/15 border border-gold/40 flex items-center justify-center mt-0.5">
                                                <Check size={11} className="text-gold" />
                                            </div>
                                            <span>{b}</span>
                                        </li>
                                    ))}
                                </ul>

                                <a
                                    href={buildWaLink(p)}
                                    target="_blank"
                                    rel="noreferrer"
                                    data-testid={`package-cta-${p.id}`}
                                    className={`mt-8 inline-flex items-center justify-center gap-2 font-oswald font-bold uppercase tracking-wider px-6 py-4 rounded transition-all duration-300 ${
                                        p.highlight
                                            ? "bg-gold text-ink hover:bg-gold-bright hover:shadow-[0_0_24px_rgba(212,175,55,0.45)]"
                                            : "border border-gold/40 text-white hover:bg-gold hover:text-ink hover:border-gold"
                                    }`}
                                >
                                    Scegli {p.name}
                                </a>
                            </div>
                        </article>
                    ))}
                </div>

                {/* Payment methods */}
                <div className="mt-14 p-6 rounded-xl bg-ink-surface border border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
                    <div>
                        <div className="font-oswald uppercase tracking-widest text-white text-sm">
                            Metodi di pagamento
                        </div>
                        <div className="font-manrope text-xs text-zinc-500 mt-1">
                            Carta · Bonifico · Contanti · Pagamenti a rate disponibili
                        </div>
                    </div>
                    <div className="flex flex-wrap items-center gap-3">
                        {["Carta", "Bonifico", "Contanti", "Rate"].map((m) => (
                            <span
                                key={m}
                                className="px-4 py-2 rounded-full bg-ink border border-gold/30 font-oswald uppercase text-xs tracking-widest text-gold"
                            >
                                {m}
                            </span>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
